
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13057',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13057",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9880",
  "foundations-components": "static-1.8347",
  "foundations-components-legacy": "static-1.1372",
  "foundations-theming": "static-1.4673",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8247",
  "hub-http-shared-msw-handlers": "static-1.10485",
  "hubspot-dlb": "static-2.1877",
  "hubspot-url-utils": "static-1.4282",
  "HubStyleTokens": "static-2.11703",
  "I18n": "static-7.1652",
  "jasmine-runner": "static-1.6671",
  "marketplace-discovery-studio-lib": "static-1.508",
  "marketplace-storefront-base": "static-1.13120",
  "quartz": "static-1.7330",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16929",
  "reactive-variable-buffer-atom": "static-1.3077",
  "reporting-testing-lib": "static-1.10418",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12742",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7523",
  "ui-addon-i18n": "static-1.11368",
  "ui-addon-react-router-dom": "static-1.9755",
  "unified-auth": "static-1.760",
  "unified-auth-core-lib": "static-1.1042",
  "usage-tracker": "static-1.7579",
  "usage-tracker-core": "static-1.7429",
  "customer-data-property-utils": "static-1.8319",
  "hub-http": "static-1.6436",
  "integrations-lib": "static-1.16870",
  "marketplace-ui-common": "static-1.20505",
  "marketplace-ui-install": "static-1.491",
  "property-management-iframe": "static-1.13907",
  "quartz-config": "static-1.1108",
  "quartz-core": "static-1.6549",
  "quartz-routing": "static-1.760",
  "quick-fetch": "static-1.4071",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4884",
  "ts-schema": "static-1.4232",
  "ui-universal-auth": "static-1.9246",
  "UIComponents": "static-3.8649",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3554",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3607",
  "quartz-webpack": "static-1.3554",
  "bend-plugin-quartz-routing": "static-1.408",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4616",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5097",
  "foundations-theming-specialty": "static-1.2389",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9648",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.52",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5495",
  "react-virtualized": "static-2.103",
  "StyleGuideUI": "static-3.492",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2395",
  "ui-fonts": "static-1.965",
  "ui-images": "static-2.1219",
  "bend-plugin-foundations-theming": "static-1.3156",
  "foundations-theming-base": "static-1.3658",
  "stylex": "static-1.37",
  "HeadJS": "static-2.782",
  "hs-test-utils-bend-plugin": "static-1.3358",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4541",
  "ui-addon-video-player": "static-1.8928",
  "ai-components-ui-library": "static-1.9530",
  "ai-rendering-library": "static-1.10950",
  "chirp-fetch": "static-1.2110",
  "connections-embed-lib": "static-1.1393",
  "copilot-toolkit": "static-1.11697",
  "feedback-loader": "static-1.29698",
  "laboratory-lib": "static-3.7374",
  "marketplace-embed": "static-1.22762",
  "marketplace-ui-details": "static-1.10400",
  "marketplace-ui-reviews": "static-1.20460",
  "marketplace-ui-tracking": "static-1.14675",
  "sanitize-text": "static-1.8371",
  "usage-tracker-multi": "static-1.5993",
  "usage-tracker-session-replay": "static-1.5265",
  "wootric-nps": "static-1.7140",
  "quartz-head": "static-1.995",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4879",
  "immer": "static-1.94",
  "immerable": "static-1.4372",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2635",
  "reporting-data": "static-1.68485",
  "cssUtils": "static-1.857",
  "flux-actions": "static-1.356",
  "HubStyle": "static-2.12010",
  "PatternValidationJS": "static-1.3119",
  "react-colorpicker": "static-2.10429",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10587",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7569",
  "icons": "static-2.671",
  "marketplace-ui-apps-core": "static-1.19037",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4732",
  "foundations-components-test-utils": "static-1.5830",
  "quartz-i18n": "static-1.1005",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.305",
  "ads-unified-auth-lib": "static-1.876",
  "google-sheets-integration-lib": "static-1.883",
  "microsoft-drive-integration-lib": "static-1.1016",
  "surveymonkey-integration-lib": "static-1.327",
  "slack-ui-library": "static-1.10618",
  "fsm": "static-1.3959",
  "customer-data-objects": "static-1.7906",
  "property-translator": "static-1.5617",
  "hs-locale-management": "static-1.234",
  "frontend-preferences-client": "static-1.8150",
  "hs-promise-utils": "static-1.5817",
  "hubspot-apollo-client": "static-1.5099",
  "integrations-error-boundary-lib": "static-1.14285",
  "integrations-tracking-lib": "static-1.5830",
  "native-integrations-shared-strings": "static-1.7999",
  "sanitize": "static-1.4698",
  "superstore": "static-1.4979",
  "ui-shepherd-react": "static-3.10484",
  "ai-settings-ui-library": "static-1.8222",
  "hub-http-janus": "static-1.860",
  "hubspotter-http": "static-1.4803",
  "immutable-less": "static-1.4872",
  "marketplace-ui-client-types": "static-1.17912",
  "nav-meta": "static-1.30316",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18293",
  "ui-product-approvals-common": "static-1.841",
  "ai-studio-lib": "static-1.12292",
  "hubspot-prosemirror": "static-1.18852",
  "integrations-reconnect-lib": "static-1.366",
  "ui-addon-iframeable": "static-1.9298",
  "ui-addon-integrations-directory-panel": "static-2.8247",
  "ui-product-approvals": "static-1.28946",
  "ui-tool-access": "static-1.10375",
  "inbound-db-properties-service-client": "static-1.3999",
  "property-management-common": "static-1.6195",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1005",
  "quartz-test": "static-1.1005",
  "quartz-tracking": "static-1.709",
  "trellis-components": "static-1.2414",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.294",
  "bender-build-tools": "static-1.3347",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22492",
  "ContentUtils": "static-1.69003",
  "customer-data-objects-ui-components": "static-1.13253",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2720",
  "breeze-engine-core": "static-1.791",
  "breeze-onboarding-components": "static-1.569",
  "customer-data-filters-ui": "static-1.40672",
  "customer-data-reference-ui-components": "static-1.13400",
  "embedded-academy-lib": "static-1.15274",
  "ExportDialog": "static-6.10602",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41862",
  "reporting-snowflake": "static-1.57103",
  "reporting-ui-components": "static-2.65756",
  "reporting-visualizations": "static-1.60561",
  "trellis-theming": "static-1.1177",
  "ui-addon-teams": "static-1.21828",
  "upgrade-components-lib": "static-1.427",
  "magpie-lib": "static-1.5705",
  "navigation-components": "static-1.18679",
  "breeze-engine-lib": "static-1.1513",
  "magpie-types": "static-1.5165",
  "simple-logging-lib": "static-1.3271",
  "fail-safe": "static-1.173",
  "app-governance-lib": "static-1.2242",
  "developer-experience-shared-components": "static-1.10720",
  "purchase-motions-components": "static-1.6254",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9927",
  "usage-tracker-anonymous": "static-1.5996",
  "usage-tracker-public": "static-1.7390",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3924",
  "reference-resolvers": "static-1.8404",
  "ui-extensibility-client-types": "static-1.4142",
  "hubspot-apollo-cache": "static-1.558",
  "universal-page-editor-lib": "static-1.3233",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3396",
  "atom": "static-1.5298",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10862",
  "ui-addon-draggable": "static-3.4978",
  "content-assistance-lib": "static-1.8100",
  "content-media-capture": "static-1.5229",
  "customer-data-ui-utilities": "static-1.10048",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24299",
  "growth-payments-core": "static-1.26023",
  "knowledge-content-types": "static-1.8614",
  "payment-link-components": "static-1.24034",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20200",
  "ui-addon-emoji-picker": "static-1.10108",
  "ui-business-units-lib": "static-1.9303",
  "video-components-external": "static-1.11995",
  "video-data-lib": "static-1.35653",
  "navigation-messaging": "static-1.8006",
  "collaboration-sidebar": "static-1.58556",
  "react-dnd-compat": "static-1.4838",
  "batch-promise": "static-1.1767",
  "crm-component-utils": "static-1.39688",
  "crm-properties-common-lib": "static-1.6111",
  "customer-data-properties": "static-1.52359",
  "external-options-client-types": "static-1.4280",
  "framework-data-schema-resolvers": "static-1.7115",
  "property-value-citations": "static-1.2973",
  "reference-resolvers-lite": "static-1.8321",
  "hubspotter-http-shared-msw-handlers": "static-1.10483",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5037",
  "content-icons-ui": "static-1.2292",
  "breeze-artifacts-sdk": "static-1.105",
  "onboarding-journeys-lib": "static-1.738",
  "pulse": "static-1.844",
  "conversations-skeleton-state": "static-1.7471",
  "crm-message-bus": "static-1.43583",
  "customer-data-filters-ui-msw-helpers": "static-1.23107",
  "events-data-lib": "static-1.463",
  "FormUrlGenerator": "static-2.4947",
  "framework-builder-read-service-client": "static-1.4161",
  "framework-data-schema-quick-fetch": "static-1.7020",
  "multi-account-reference-resolvers": "static-1.1216",
  "onboarding-tours": "static-1.17005",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14322",
  "academy-common-lib": "static-1.14734",
  "dashboard-lib": "static-1.82480",
  "getting-started-shared-tasks": "static-1.19063",
  "hubspot-prosemirror-plugins": "static-1.18844",
  "share-with-third-party-component-lib": "static-1.8926",
  "ui-asset-management-lib": "static-1.11312",
  "user-context": "static-1.5335",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68163",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.942",
  "nest": "static-1.460",
  "breeze-engine-chat-components": "static-1.491",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.124",
  "framework-listing-lib": "static-2.29324",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31257",
  "apps-service-types": "static-1.3988",
  "oauth-service-types": "static-1.4476",
  "onboarding-scopes": "static-1.6681",
  "purchase-motions-api": "static-1.6257",
  "signup-constants": "static-1.19449",
  "signup-ui-url-generator": "static-2.8280",
  "onboarding-tours-client": "static-1.5219",
  "one-click-checkout": "static-1.304",
  "platform-infra-nav-components": "static-1.7824",
  "subscription-experience-data-types": "static-1.15167",
  "crm-record-cards-service-types": "static-1.3735",
  "location-customization-utils-lib": "static-1.9943",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29168",
  "content-media-composition-data-lib": "static-1.13033",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4647",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.551",
  "ui-addon-opt": "static-4.8584",
  "commerce-tours-lib": "static-1.6500",
  "growth-onboarding-reliability": "static-1.5302",
  "sales-checkout-service-client": "static-1.3758",
  "data-token-picker": "static-1.16783",
  "FileManagerLib": "static-1.39939",
  "content-media-compositions": "static-2.17040",
  "media-bridge-lib": "static-1.19302",
  "chatspot-widget-iframe": "static-1.22483",
  "collaboration-sidebar-common": "static-1.3353",
  "marketing-platform-lib": "static-1.7091",
  "card-properties-lib": "static-1.44855",
  "commerce-subscription-lib": "static-1.37630",
  "crm-actions": "static-1.6572",
  "crm-cards-sdk": "static-1.44318",
  "customer-data-properties-shared-msw-handlers": "static-1.9812",
  "customer-data-tracking": "static-1.7105",
  "hs-resources": "static-1.409",
  "calling-global-api": "static-1.65286",
  "calling-internal-common": "static-1.31538",
  "calling-lifecycle-internal": "static-1.66668",
  "calling-lifecycle-messages": "static-1.58962",
  "commerce-products-lib": "static-1.10352",
  "conditional-properties-service-client": "static-1.3951",
  "crm-links": "static-1.6541",
  "crm-index-visualization-core": "static-1.4437",
  "crm-pipelines-api-client-types": "static-1.4289",
  "formula-editor": "static-1.14641",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4365",
  "meetings-icalendar-utils-lib": "static-1.857",
  "multi-currency-client-types": "static-1.3845",
  "object-builder-ui-client": "static-1.49465",
  "pipeline-validation-client-types": "static-1.4121",
  "smart-property-lib": "static-1.8130",
  "tiered-pricing": "static-1.1820",
  "topics-actions-lib": "static-1.380",
  "ui-addon-form-validation": "static-1.11208",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.234",
  "bend-plugin-pulse": "static-1.347",
  "event-emitter": "static-1.1174",
  "fast-json-patch": "static-1.66",
  "restore-request-side-panel-lib": "static-1.1480",
  "growth-data-modal": "static-1.5784",
  "growth-onboarding-confetti": "static-1.3283",
  "growth-onboarding-next-action-utils": "static-1.2547",
  "onboarding-tours-utils": "static-1.1071",
  "ui-shepherd-tracker": "static-1.7865",
  "academy-service-client": "static-1.3912",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39798",
  "SafeStorage": "static-1.4625",
  "video-embed": "static-1.36487",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24873",
  "viral-links-lib": "static-1.7295",
  "nested-table": "static-1.457",
  "timezone-utils": "static-2.5469",
  "getting-started-shared-tasks-store": "static-1.18181",
  "campaign-roi-lib": "static-1.9937",
  "ui-addon-calendars": "static-2.5547",
  "customer-data-views-management": "static-1.25895",
  "framework-data-table": "static-2.12403",
  "nudge-client-utils": "static-1.3032",
  "nudge-custom-ui-functions": "static-1.1386",
  "switchboard-lib": "static-1.442",
  "access-check-ui-lib": "static-1.1431",
  "app-users-service-client": "static-1.5840",
  "app-users-service-types": "static-1.5248",
  "mini-checkout-client": "static-1.27399",
  "onboarding-utils": "static-1.5585",
  "permissions-shared-i18n-strings-fe": "static-1.2105",
  "ui-coaching-tips-shared-config": "static-1.29153",
  "checkout-sdk": "static-3.24242",
  "payment-method-components": "static-1.7070",
  "touchless-buying-components": "static-1.6110",
  "upgrade-catalog-service-types": "static-1.3706",
  "edison-service-client-types": "static-1.611",
  "growth-onboarding-feedback-components": "static-1.6804",
  "audio-components": "static-1.6241",
  "FileManagerImages": "static-1.37450",
  "video-components": "static-1.13997",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92689",
  "customer-data-sidebar": "static-2.46600",
  "enrichment-properties-lib": "static-1.17686",
  "ui-addon-draggable-compat": "static-2.4483",
  "universal-record-utils-lib": "static-1.1651",
  "commerce-billing-lib": "static-1.19883",
  "commerce-shared-components-lib": "static-1.19086",
  "commerce-tools-ui-lib": "static-1.10917",
  "crm-fe-perf": "static-1.23121",
  "calling-error-reporting": "static-1.31545",
  "shared-worker-versioning": "static-1.11261",
  "calling-usage-tracker": "static-1.6761",
  "voice-sms-access-library": "static-1.1805",
  "commerce-permissions": "static-1.999",
  "products-iframe-lib": "static-1.8453",
  "products-ui-components-shared-msw-handlers": "static-1.10867",
  "crm-index-associations-lib": "static-1.6663",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10568",
  "sales-views-client-types": "static-1.4479",
  "bark-lib": "static-1.16727",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.538",
  "policy-lib": "static-1.7015",
  "react-tinymce": "static-1.55827",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10631",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54953",
  "tinymce-plugins": "static-1.58067",
  "tinymce-themes": "static-1.56923",
  "onboarding-data-sync-lib": "static-1.2354",
  "growth-onboarding-next-action-components": "static-1.2575",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4755",
  "outpost": "static-1.4385",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22050",
  "sales-email-signature-service-client": "static-1.4067",
  "ts-utils-lib": "static-1.397",
  "crm-export-dialog": "static-1.6507",
  "crm-view-components": "static-1.942",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7554",
  "nudge-custom-function-registry": "static-1.2789",
  "nudge-renderer-utils": "static-1.3108",
  "whisper-core-api": "static-1.7176",
  "InboxConnectUtils": "static-4.15410",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46700",
  "hub-http-rxjs": "static-1.825",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4213",
  "company-details-components": "static-1.6424",
  "react-performance-metrics-lib": "static-1.776",
  "pricing-pages-ui-components": "static-1.15339",
  "quote-checkout-service-types": "static-1.3677",
  "social-insights-client-types": "static-1.22661",
  "crm_universal": "static-1.22389",
  "customer-data-email": "static-1.18418",
  "card-payment-highlight-lib": "static-1.37824",
  "card-subscription-highlight-lib": "static-1.40053",
  "commerce-contract-lib": "static-1.13093",
  "invoices-highlight-card-lib": "static-1.55456",
  "orders-highlight-card-lib": "static-1.22044",
  "products-highlight-card-lib": "static-1.18635",
  "quotes-highlight-card-lib": "static-1.72693",
  "crm-source-interpretation-lib": "static-1.5556",
  "crm-object-search-query-utilities": "static-1.10070",
  "utility-belt": "static-1.2754",
  "payments-enrollment-embed-lib": "static-1.23660",
  "stripe-embedded-components": "static-1.7889",
  "customer-data-rte": "static-1.33520",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6158",
  "payments-post-enroll-local-storage-lib": "static-1.5329",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38783",
  "calling-orchestration-schema": "static-1.36582",
  "react-reducer-toolkit": "static-1.16221",
  "hub-http-contrib": "static-1.3261",
  "interframe": "static-3.4977",
  "tinymce-data": "static-1.41038",
  "ui-addon-sales-email": "static-1.5435",
  "layout-dnd-components": "static-1.12856",
  "layout-dnd-utils": "static-1.11831",
  "ui-brand-identity-lib": "static-1.16129",
  "NamespacedHubStyle": "static-2.9203",
  "meetings-connect-utils-lib": "static-1.7829",
  "access-control-lib": "static-1.10660",
  "EmailComponents": "static-1.55405",
  "EmailData": "static-1.54083",
  "redux-less": "static-2.9702",
  "company-details-service-types": "static-1.4161",
  "segments-query-core": "static-1.1645",
  "pricing-pages-api": "static-1.15204",
  "sequences-lib": "static-1.8415",
  "ui-gdpr-components": "static-1.10576",
  "products-ui-components": "static-1.40870",
  "accounting-integrations-ui-components": "static-1.7431",
  "invoices-ui-lib": "static-1.55472",
  "commerce-products-api": "static-1.2611",
  "invoices-iframe-lib": "static-1.57530",
  "quotes-modal-lib": "static-1.103371",
  "quotes-ui-lib": "static-1.81414",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28784",
  "ContentData": "static-1.69078",
  "layout-data-lib": "static-1.10156",
  "ContentComponents": "static-2.71959",
  "marketing-contacts-lib": "static-1.10813",
  "marketing-email-service-types": "static-1.2060",
  "messaging-editing-lib": "static-1.46981",
  "messaging-usage-based-billing-components-lib": "static-1.1843",
  "automation-ui-source-apps": "static-1.19517",
  "automation-ui-types": "static-1.20435",
  "messaging-types-lib": "static-1.46718",
  "onboarding-settings-client": "static-1.4731",
  "sequences-client-types-lib": "static-1.8272",
  "commerce-tax-lib": "static-1.763",
  "price-books-api": "static-1.1572",
  "price-books-components": "static-1.1630",
  "property-description-translator": "static-1.4061",
  "ramp-editor": "static-1.754",
  "commerce-analytics-service-client": "static-1.3746",
  "totals-ui-components": "static-1.24163",
  "SalesContentIndexUI": "static-3.9538",
  "advanced-menus-core": "static-1.15482",
  "advanced-menus-lib": "static-1.12367",
  "ui-memberships-settings-lib": "static-1.34663",
  "automation-ui-ubb": "static-1.6351",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7556",
  "data-token-views": "static-1.16764",
  "forms-utils-lib": "static-1.12983",
  "payments-embed-points-lib": "static-1.13472",
  "simple-menus-core": "static-1.15481",
  "simple-menus-lib": "static-1.16998",
  "videoconference-integration-components": "static-1.7144",
  "marketing-contacts-client": "static-1.7729",
  "mc-hard-limits-client-types": "static-1.123",
  "automation-applications-service-types": "static-1.3635",
  "automation-platform-service-types": "static-1.2646",
  "ContentEditorUI": "static-2.77743",
  "short-messages-app-service-client": "static-1.4143",
  "web-interactives-components": "static-1.14140",
  "web-interactives-data": "static-1.14141",
  "messaging-shared-utils-lib": "static-1.1292",
  "messaging-user-info-utils-lib": "static-1.1462",
  "email-portal-health-service-types": "static-1.1200",
  "line-items-api": "static-1.1008",
  "commerce-totals-service-types": "static-1.3970",
  "FireAlarmUi": "static-1.4662",
  "sales-templates-service-types-lib": "static-1.4322",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22371",
  "automation-ui-usage-tracking": "static-1.21834",
  "data-studio-ubb": "static-1.3366",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27529",
  "content-management-data-lib": "static-1.5833",
  "copilot-plugins": "static-1.11669",
  "cta-picker": "static-1.36951",
  "customer-agent-discovery-components-lib": "static-1.3733",
  "editor-components": "static-1.13545",
  "editor-iframe-lib": "static-1.8703",
  "error-messaging-js": "static-1.5417",
  "FormsCommonComponents": "static-1.86437",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10871",
  "SharedLegalStrings": "static-1.1968",
  "smart-content-core": "static-1.43033",
  "smart-content-lib": "static-1.43686",
  "social-composer-lib": "static-1.59997",
  "structured-content-lib": "static-1.25778",
  "theme-previewer-lib": "static-1.53804",
  "tinymce-copilot": "static-1.17021",
  "xray-recommendation-lib": "static-1.8180",
  "automation-ui-routing": "static-1.21792",
  "sql-reporting-client-types": "static-1.5827",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42663",
  "campaigns-utils-lib": "static-1.3420",
  "reporting-enablement": "static-1.23659",
  "forms-ai-lib": "static-1.4656",
  "codemirror-dlb": "static-1.59302",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6661",
  "report-customization-components": "static-1.13753",
  "data-quality-ui-library": "static-1.13624",
  "reporting-filters": "static-1.868",
  "reporting-insights-lib": "static-1.2409"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13057",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9880",
  "foundations-components": "/foundations-components/static-1.8347",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1372",
  "foundations-theming": "/foundations-theming/static-1.4673",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8247",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10485",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyleTokens": "/HubStyleTokens/static-2.11703",
  "I18n": "/I18n/static-7.1652",
  "jasmine-runner": "/jasmine-runner/static-1.6671",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.508",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13120",
  "quartz": "/quartz/static-1.7330",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16929",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3077",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10418",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12742",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7523",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11368",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9755",
  "unified-auth": "/unified-auth/static-1.760",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1042",
  "usage-tracker": "/usage-tracker/static-1.7579",
  "usage-tracker-core": "/usage-tracker-core/static-1.7429",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8319",
  "hub-http": "/hub-http/static-1.6436",
  "integrations-lib": "/integrations-lib/static-1.16870",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20505",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.491",
  "property-management-iframe": "/property-management-iframe/static-1.13907",
  "quartz-config": "/quartz-config/static-1.1108",
  "quartz-core": "/quartz-core/static-1.6549",
  "quartz-routing": "/quartz-routing/static-1.760",
  "quick-fetch": "/quick-fetch/static-1.4071",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4884",
  "ts-schema": "/ts-schema/static-1.4232",
  "ui-universal-auth": "/ui-universal-auth/static-1.9246",
  "UIComponents": "/UIComponents/static-3.8649",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3554",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3607",
  "quartz-webpack": "/quartz-webpack/static-1.3554",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.408",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4616",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5097",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2389",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9648",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5495",
  "react-virtualized": "/react-virtualized/static-2.103",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2395",
  "ui-fonts": "/ui-fonts/static-1.965",
  "ui-images": "/ui-images/static-2.1219",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3156",
  "foundations-theming-base": "/foundations-theming-base/static-1.3658",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.782",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3358",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4541",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8928",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9530",
  "ai-rendering-library": "/ai-rendering-library/static-1.10950",
  "chirp-fetch": "/chirp-fetch/static-1.2110",
  "connections-embed-lib": "/connections-embed-lib/static-1.1393",
  "copilot-toolkit": "/copilot-toolkit/static-1.11697",
  "feedback-loader": "/feedback-loader/static-1.29698",
  "laboratory-lib": "/laboratory-lib/static-3.7374",
  "marketplace-embed": "/marketplace-embed/static-1.22762",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10400",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20460",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14675",
  "sanitize-text": "/sanitize-text/static-1.8371",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5993",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5265",
  "wootric-nps": "/wootric-nps/static-1.7140",
  "quartz-head": "/quartz-head/static-1.995",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4879",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4372",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2635",
  "reporting-data": "/reporting-data/static-1.68485",
  "cssUtils": "/cssUtils/static-1.857",
  "flux-actions": "/flux-actions/static-1.356",
  "HubStyle": "/HubStyle/static-2.12010",
  "PatternValidationJS": "/PatternValidationJS/static-1.3119",
  "react-colorpicker": "/react-colorpicker/static-2.10429",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10587",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7569",
  "icons": "/icons/static-2.671",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19037",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4732",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5830",
  "quartz-i18n": "/quartz-i18n/static-1.1005",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.305",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.876",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.883",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1016",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.327",
  "slack-ui-library": "/slack-ui-library/static-1.10618",
  "fsm": "/fsm/static-1.3959",
  "customer-data-objects": "/customer-data-objects/static-1.7906",
  "property-translator": "/property-translator/static-1.5617",
  "hs-locale-management": "/hs-locale-management/static-1.234",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8150",
  "hs-promise-utils": "/hs-promise-utils/static-1.5817",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5099",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14285",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5830",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7999",
  "sanitize": "/sanitize/static-1.4698",
  "superstore": "/superstore/static-1.4979",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10484",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8222",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "hubspotter-http": "/hubspotter-http/static-1.4803",
  "immutable-less": "/immutable-less/static-1.4872",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17912",
  "nav-meta": "/nav-meta/static-1.30316",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18293",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.841",
  "ai-studio-lib": "/ai-studio-lib/static-1.12292",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.366",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9298",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8247",
  "ui-product-approvals": "/ui-product-approvals/static-1.28946",
  "ui-tool-access": "/ui-tool-access/static-1.10375",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3999",
  "property-management-common": "/property-management-common/static-1.6195",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1005",
  "quartz-test": "/quartz-test/static-1.1005",
  "quartz-tracking": "/quartz-tracking/static-1.709",
  "trellis-components": "/trellis-components/static-1.2414",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.294",
  "bender-build-tools": "/bender-build-tools/static-1.3347",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22492",
  "ContentUtils": "/ContentUtils/static-1.69003",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13253",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2720",
  "breeze-engine-core": "/breeze-engine-core/static-1.791",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.569",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40672",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13400",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15274",
  "ExportDialog": "/ExportDialog/static-6.10602",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41862",
  "reporting-snowflake": "/reporting-snowflake/static-1.57103",
  "reporting-ui-components": "/reporting-ui-components/static-2.65756",
  "reporting-visualizations": "/reporting-visualizations/static-1.60561",
  "trellis-theming": "/trellis-theming/static-1.1177",
  "ui-addon-teams": "/ui-addon-teams/static-1.21828",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.427",
  "magpie-lib": "/magpie-lib/static-1.5705",
  "navigation-components": "/navigation-components/static-1.18679",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1513",
  "magpie-types": "/magpie-types/static-1.5165",
  "simple-logging-lib": "/simple-logging-lib/static-1.3271",
  "fail-safe": "/fail-safe/static-1.173",
  "app-governance-lib": "/app-governance-lib/static-1.2242",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10720",
  "purchase-motions-components": "/purchase-motions-components/static-1.6254",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9927",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5996",
  "usage-tracker-public": "/usage-tracker-public/static-1.7390",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3924",
  "reference-resolvers": "/reference-resolvers/static-1.8404",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4142",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.558",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3233",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3396",
  "atom": "/atom/static-1.5298",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10862",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4978",
  "content-assistance-lib": "/content-assistance-lib/static-1.8100",
  "content-media-capture": "/content-media-capture/static-1.5229",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10048",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24299",
  "growth-payments-core": "/growth-payments-core/static-1.26023",
  "knowledge-content-types": "/knowledge-content-types/static-1.8614",
  "payment-link-components": "/payment-link-components/static-1.24034",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20200",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10108",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9303",
  "video-components-external": "/video-components-external/static-1.11995",
  "video-data-lib": "/video-data-lib/static-1.35653",
  "navigation-messaging": "/navigation-messaging/static-1.8006",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58556",
  "react-dnd-compat": "/react-dnd-compat/static-1.4838",
  "batch-promise": "/batch-promise/static-1.1767",
  "crm-component-utils": "/crm-component-utils/static-1.39688",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6111",
  "customer-data-properties": "/customer-data-properties/static-1.52359",
  "external-options-client-types": "/external-options-client-types/static-1.4280",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7115",
  "property-value-citations": "/property-value-citations/static-1.2973",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8321",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10483",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5037",
  "content-icons-ui": "/content-icons-ui/static-1.2292",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.105",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.738",
  "pulse": "/pulse/static-1.844",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7471",
  "crm-message-bus": "/crm-message-bus/static-1.43583",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23107",
  "events-data-lib": "/events-data-lib/static-1.463",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4947",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4161",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7020",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1216",
  "onboarding-tours": "/onboarding-tours/static-1.17005",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14322",
  "academy-common-lib": "/academy-common-lib/static-1.14734",
  "dashboard-lib": "/dashboard-lib/static-1.82480",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19063",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8926",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11312",
  "user-context": "/user-context/static-1.5335",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68163",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.942",
  "nest": "/nest/static-1.460",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.491",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.124",
  "framework-listing-lib": "/framework-listing-lib/static-2.29324",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31257",
  "apps-service-types": "/apps-service-types/static-1.3988",
  "oauth-service-types": "/oauth-service-types/static-1.4476",
  "onboarding-scopes": "/onboarding-scopes/static-1.6681",
  "purchase-motions-api": "/purchase-motions-api/static-1.6257",
  "signup-constants": "/signup-constants/static-1.19449",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8280",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5219",
  "one-click-checkout": "/one-click-checkout/static-1.304",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7824",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15167",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3735",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9943",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29168",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13033",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4647",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.551",
  "ui-addon-opt": "/ui-addon-opt/static-4.8584",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6500",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5302",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3758",
  "data-token-picker": "/data-token-picker/static-1.16783",
  "FileManagerLib": "/FileManagerLib/static-1.39939",
  "content-media-compositions": "/content-media-compositions/static-2.17040",
  "media-bridge-lib": "/media-bridge-lib/static-1.19302",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22483",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3353",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7091",
  "card-properties-lib": "/card-properties-lib/static-1.44855",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37630",
  "crm-actions": "/crm-actions/static-1.6572",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44318",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9812",
  "customer-data-tracking": "/customer-data-tracking/static-1.7105",
  "hs-resources": "/hs-resources/static-1.409",
  "calling-global-api": "/calling-global-api/static-1.65286",
  "calling-internal-common": "/calling-internal-common/static-1.31538",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66668",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58962",
  "commerce-products-lib": "/commerce-products-lib/static-1.10352",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3951",
  "crm-links": "/crm-links/static-1.6541",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4437",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4289",
  "formula-editor": "/formula-editor/static-1.14641",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4365",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.857",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3845",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49465",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4121",
  "smart-property-lib": "/smart-property-lib/static-1.8130",
  "tiered-pricing": "/tiered-pricing/static-1.1820",
  "topics-actions-lib": "/topics-actions-lib/static-1.380",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11208",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.234",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.347",
  "event-emitter": "/event-emitter/static-1.1174",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1480",
  "growth-data-modal": "/growth-data-modal/static-1.5784",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3283",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2547",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1071",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7865",
  "academy-service-client": "/academy-service-client/static-1.3912",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39798",
  "SafeStorage": "/SafeStorage/static-1.4625",
  "video-embed": "/video-embed/static-1.36487",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24873",
  "viral-links-lib": "/viral-links-lib/static-1.7295",
  "nested-table": "/nested-table/static-1.457",
  "timezone-utils": "/timezone-utils/static-2.5469",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18181",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9937",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5547",
  "customer-data-views-management": "/customer-data-views-management/static-1.25895",
  "framework-data-table": "/framework-data-table/static-2.12403",
  "nudge-client-utils": "/nudge-client-utils/static-1.3032",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1386",
  "switchboard-lib": "/switchboard-lib/static-1.442",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1431",
  "app-users-service-client": "/app-users-service-client/static-1.5840",
  "app-users-service-types": "/app-users-service-types/static-1.5248",
  "mini-checkout-client": "/mini-checkout-client/static-1.27399",
  "onboarding-utils": "/onboarding-utils/static-1.5585",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2105",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29153",
  "checkout-sdk": "/checkout-sdk/static-3.24242",
  "payment-method-components": "/payment-method-components/static-1.7070",
  "touchless-buying-components": "/touchless-buying-components/static-1.6110",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3706",
  "edison-service-client-types": "/edison-service-client-types/static-1.611",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6804",
  "audio-components": "/audio-components/static-1.6241",
  "FileManagerImages": "/FileManagerImages/static-1.37450",
  "video-components": "/video-components/static-1.13997",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92689",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46600",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17686",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4483",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1651",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19883",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19086",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10917",
  "crm-fe-perf": "/crm-fe-perf/static-1.23121",
  "calling-error-reporting": "/calling-error-reporting/static-1.31545",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11261",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6761",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1805",
  "commerce-permissions": "/commerce-permissions/static-1.999",
  "products-iframe-lib": "/products-iframe-lib/static-1.8453",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10867",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6663",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10568",
  "sales-views-client-types": "/sales-views-client-types/static-1.4479",
  "bark-lib": "/bark-lib/static-1.16727",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.538",
  "policy-lib": "/policy-lib/static-1.7015",
  "react-tinymce": "/react-tinymce/static-1.55827",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10631",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54953",
  "tinymce-plugins": "/tinymce-plugins/static-1.58067",
  "tinymce-themes": "/tinymce-themes/static-1.56923",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2354",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2575",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4755",
  "outpost": "/outpost/static-1.4385",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22050",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4067",
  "ts-utils-lib": "/ts-utils-lib/static-1.397",
  "crm-export-dialog": "/crm-export-dialog/static-1.6507",
  "crm-view-components": "/crm-view-components/static-1.942",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7554",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2789",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3108",
  "whisper-core-api": "/whisper-core-api/static-1.7176",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15410",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46700",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.825",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4213",
  "company-details-components": "/company-details-components/static-1.6424",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.776",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15339",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3677",
  "social-insights-client-types": "/social-insights-client-types/static-1.22661",
  "crm_universal": "/crm_universal/static-1.22389",
  "customer-data-email": "/customer-data-email/static-1.18418",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37824",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40053",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13093",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55456",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22044",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18635",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72693",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5556",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10070",
  "utility-belt": "/utility-belt/static-1.2754",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23660",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7889",
  "customer-data-rte": "/customer-data-rte/static-1.33520",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6158",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5329",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38783",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36582",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16221",
  "hub-http-contrib": "/hub-http-contrib/static-1.3261",
  "interframe": "/interframe/static-3.4977",
  "tinymce-data": "/tinymce-data/static-1.41038",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5435",
  "layout-dnd-components": "/layout-dnd-components/static-1.12856",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11831",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16129",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9203",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7829",
  "access-control-lib": "/access-control-lib/static-1.10660",
  "EmailComponents": "/EmailComponents/static-1.55405",
  "EmailData": "/EmailData/static-1.54083",
  "redux-less": "/redux-less/static-2.9702",
  "company-details-service-types": "/company-details-service-types/static-1.4161",
  "segments-query-core": "/segments-query-core/static-1.1645",
  "pricing-pages-api": "/pricing-pages-api/static-1.15204",
  "sequences-lib": "/sequences-lib/static-1.8415",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10576",
  "products-ui-components": "/products-ui-components/static-1.40870",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7431",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55472",
  "commerce-products-api": "/commerce-products-api/static-1.2611",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57530",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103371",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81414",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28784",
  "ContentData": "/ContentData/static-1.69078",
  "layout-data-lib": "/layout-data-lib/static-1.10156",
  "ContentComponents": "/ContentComponents/static-2.71959",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10813",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2060",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46981",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1843",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19517",
  "automation-ui-types": "/automation-ui-types/static-1.20435",
  "messaging-types-lib": "/messaging-types-lib/static-1.46718",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4731",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8272",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.763",
  "price-books-api": "/price-books-api/static-1.1572",
  "price-books-components": "/price-books-components/static-1.1630",
  "property-description-translator": "/property-description-translator/static-1.4061",
  "ramp-editor": "/ramp-editor/static-1.754",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3746",
  "totals-ui-components": "/totals-ui-components/static-1.24163",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9538",
  "advanced-menus-core": "/advanced-menus-core/static-1.15482",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12367",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34663",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6351",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7556",
  "data-token-views": "/data-token-views/static-1.16764",
  "forms-utils-lib": "/forms-utils-lib/static-1.12983",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13472",
  "simple-menus-core": "/simple-menus-core/static-1.15481",
  "simple-menus-lib": "/simple-menus-lib/static-1.16998",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7144",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7729",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.123",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3635",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2646",
  "ContentEditorUI": "/ContentEditorUI/static-2.77743",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4143",
  "web-interactives-components": "/web-interactives-components/static-1.14140",
  "web-interactives-data": "/web-interactives-data/static-1.14141",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1292",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1462",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1200",
  "line-items-api": "/line-items-api/static-1.1008",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3970",
  "FireAlarmUi": "/FireAlarmUi/static-1.4662",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4322",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22371",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21834",
  "data-studio-ubb": "/data-studio-ubb/static-1.3366",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27529",
  "content-management-data-lib": "/content-management-data-lib/static-1.5833",
  "copilot-plugins": "/copilot-plugins/static-1.11669",
  "cta-picker": "/cta-picker/static-1.36951",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3733",
  "editor-components": "/editor-components/static-1.13545",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8703",
  "error-messaging-js": "/error-messaging-js/static-1.5417",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86437",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10871",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1968",
  "smart-content-core": "/smart-content-core/static-1.43033",
  "smart-content-lib": "/smart-content-lib/static-1.43686",
  "social-composer-lib": "/social-composer-lib/static-1.59997",
  "structured-content-lib": "/structured-content-lib/static-1.25778",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53804",
  "tinymce-copilot": "/tinymce-copilot/static-1.17021",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8180",
  "automation-ui-routing": "/automation-ui-routing/static-1.21792",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5827",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42663",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3420",
  "reporting-enablement": "/reporting-enablement/static-1.23659",
  "forms-ai-lib": "/forms-ai-lib/static-1.4656",
  "codemirror-dlb": "/codemirror-dlb/static-1.59302",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6661",
  "report-customization-components": "/report-customization-components/static-1.13753",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13624",
  "reporting-filters": "/reporting-filters/static-1.868",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2409"
}
};
